import { GDPRSdk } from "../../../ads/GDPR.js";
import { ExternallyPassedContentAdData } from "../../../ads/adcall/composable/ContentSpecificAdCallFilter.js";
import { PlayerEvent } from "../../../events/PlayerEvent.js";
import { AudicomConfig } from "../AudicomPairingPing.js";
import { ComScoreConfig, ComScoreStreamingTag, ComScoreStreamingTagFactory } from "./ComScoreStreamingTag.js";

export class ComScoreStreamingTagDynamic implements ComScoreStreamingTagFactory {

    private prom: Promise<ComScoreStreamingTagFactory>;

    constructor(private cfg: ComScoreConfig,
        private gdprPromise: Promise<GDPRSdk>,
        private window: Window,
        private extData?: ExternallyPassedContentAdData,
        private audicom?: AudicomConfig) {

    }


    private getIt(): Promise<ComScoreStreamingTagFactory> {
        if (!this.prom) {
            this.prom = import(/* webpackChunkName: "ComScoreModule" */"./ComScoreStreamingTagModule").then(fn => {
                return fn.getComScoreStreamingTagFactory(this.cfg, this.gdprPromise, this.window, this.extData, this.audicom);
            });
        }
        return this.prom;
    }

    getStreamingTag(mle: PlayerEvent): Promise<ComScoreStreamingTag> {
        return this.getIt().then(stf => stf.getStreamingTag(mle));
    }




    preload(): Promise<ComScoreStreamingTagFactory> {
        return this.getIt();
    }
}